import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../../environments/environment';
import { SurveyAuthService } from '../../../../shared/survey-auth.service';
import { EmailList } from '../models/email-list';
import { Survey } from '../models/survey';
import { SurveyInvitation } from '../models/survey-invitation';

@Injectable()
export class SurveyDistributionService {
  constructor(private http: HttpClient, private auth: SurveyAuthService) {}

  private survey: Survey; // fixme needed?

  // fetch survey invitations from the server
  getSurveyInvitations(survey: Survey): Observable<SurveyInvitation[]> {
    const get_url = `${environment.surveyApiHost}/api/v1/surveys/${survey.id}/invitations/`;

    console.log('GET ' + get_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .get(get_url, { headers: headers })
      .map((response: any) => {
        const json = response;
        const invitations: SurveyInvitation[] = json.map(
          SurveyInvitation.fromJSON
        );
        return invitations;
      })
      .catch(this.handleError);
  }

  addSurveyInvitation(
    survey: Survey,
    survey_invitation: SurveyInvitation
  ): Observable<any> {
    this.survey = survey;
    const post_url = `${environment.surveyApiHost}/api/v1/surveys/${survey.id}/invitations/`;
    console.log('POST ' + post_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .post(post_url, survey_invitation.toJSON(), { headers: headers })
      .map((response: HttpResponse<any>) => {
        const json = response;
        return SurveyInvitation.fromJSON(json);
      })
      .catch(this.handleError);
  }

  updateSurveyInvitation(
    survey: Survey,
    survey_invitation: SurveyInvitation
  ): Observable<any> {
    this.survey = survey;
    const put_url = `${environment.surveyApiHost}/api/v1/surveys/${survey.id}/invitations/${survey_invitation.id}/`;
    console.log('PUT ' + put_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    console.log('survey_invitation: ', survey_invitation.toJSON());
    return this.http
      .put(put_url, survey_invitation.toJSON(), { headers: headers })
      .map((response: HttpResponse<any>) => {
        const json = response;
        return SurveyInvitation.fromJSON(json);
      })
      .catch(this.handleError);
  }

  deleteSurveyInvitation(
    survey: Survey,
    survey_invitation: SurveyInvitation
  ): Observable<any> {
    const delete_url = `${environment.surveyApiHost}/api/v1/surveys/${survey.id}/invitations/${survey_invitation.id}/`;
    console.log('DELETE ' + delete_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);
    return this.http
      .delete(delete_url, { headers: headers })
      .catch(this.handleError);
  }

  approveSurveyInvitation(
    survey: Survey,
    survey_invitation: SurveyInvitation
  ): Observable<any> {
    const put_url = `${environment.surveyApiHost}/api/v1/surveys/${survey.id}/invitations/${survey_invitation.id}/approve/`;
    console.log('PUT ' + put_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);
    return this.http
      .put(put_url, {}, { headers: headers })
      .catch(this.handleError);
  }

  updateSurveyInvitationEmailLists(
    survey: Survey,
    survey_invitation: SurveyInvitation,
    email_list_ids: number[]
  ): Observable<EmailList[]> {
    this.survey = survey;
    const put_url = `${environment.surveyApiHost}/api/v1/surveys/${survey.id}/invitations/${survey_invitation.id}/email_lists/`;
    console.log('PUT ' + put_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .put(put_url, email_list_ids, { headers: headers })
      .map((response: any) => {
        const json = response;
        const email_lists: EmailList[] = json.map(EmailList.fromJSON);
        return email_lists;
      })
      .catch(this.handleError);
  }

  private processPostPutResponse(res: HttpResponse<any>): SurveyInvitation {
    console.log('processPostResponse: res: ', res);
    const body = res.body.json();
    console.log('processResponse: body: ', body);
    const survey_invitation: SurveyInvitation = Object.create(
      SurveyInvitation.prototype
    );
    const obj = Object.assign(survey_invitation, body, {});
    console.log('this.survey: ', this.survey);
    survey_invitation.setSurvey(this.survey);
    return obj || {};
  }

  private handleError(error: HttpResponse<any> | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof HttpResponse) {
      const body = error.body.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}
